import type { FC } from "react";

import { ModalFooter } from "@aviary";
import { FooterLogos, FooterPrivacy } from "@shared/components";

import { footer, privacyPolicy } from "./SignUpModalFooter.styles";

const SignUpModalFooter: FC = () => {
  return (
    <ModalFooter css={footer}>
      <FooterLogos />
      <FooterPrivacy css={privacyPolicy} />
    </ModalFooter>
  );
};

export { SignUpModalFooter };
